import React, { useContext } from 'react';
import { Link } from "react-router-dom";
import { Heading, Text, GridColumn, GridRow, ItemListContainer, ItemList, EmailIcon, MessagingIcon } from 'react-onei';

import UserContext from '../../../context/UserContext';
import { MOBILE_TYPE } from '../../../helpers/account';
import { events } from '../../../conf/tags_ga.conf';
import TagService from '../../../services/TagService';

function ContactsItem({ contacts }) {
  const {
    wording,
    setStep,
  } = useContext(UserContext);
  const {
    WLOST_201,
    WLOST_202,
    WLOST_203,
    WLOST_204,
  } = wording;

  const handleClick = (contactType) => {
    setStep('/otc');
    TagService.sendEvent(contactType === MOBILE_TYPE ? events.resetBySms : events.resetByMail);
  }

  return (
    <>
      <GridRow>
        <GridColumn>
          <Heading as="h4" bold id="get-code-subtitle" className="spacing-m">
            {WLOST_201}
          </Heading>
          <Text id="get-code-message">{WLOST_202}</Text>
        </GridColumn>
      </GridRow>

      <GridRow>
        <GridColumn size={{ xs: 1, m: 6 / 12, l: 4 / 12 }}>
          <div className="spacing-xs">
            <ItemListContainer>
              {
                contacts.map((contact, key) => (
                  <ItemList
                    id={`contact-card-${key}`}
                    key={contact.contactId}
                    as={Link}
                    icon={contact.contactType === MOBILE_TYPE ? MessagingIcon : EmailIcon}
                    iconAttrs={{
                      'id': contact.contactType === MOBILE_TYPE ? `icon-mobile-${key}` : `icon-mail-${key}`,
                    }}
                    subLabel={contact.contactView}
                    label={contact.contactType === MOBILE_TYPE ? WLOST_203 : WLOST_204}
                    to={{
                      pathname: '/otc',
                      state: { contact },
                    }}
                    onClick={() => handleClick(contact.contactType)}
                  />
                ))
              }
            </ItemListContainer>
          </div>
        </GridColumn>
      </GridRow>
    </>
  )
}

export default ContactsItem;
